/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, EventEmitter, Input, OnInit, Output, Self } from '@angular/core';
import { ContactType } from '@gh/builder-shared-data';
import { DialogService } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { ContactDetailsDialogConfig, contactDetailsDialogRoute } from '../../../dialogs';
import { ContactMenuComponent } from './contact-menu.component';

export interface ContactChangeEvent {
  value: any;
}

@Directive({
  standalone: false,
  selector: '[ghContactMenuDialog]',
})
export class ContactMenuDialogDirective implements OnInit {
  @Input('ghContactMenuDialogEntryPoint') entryPoint: string;
  @Input('ghContactMenuDialogParentTitle') parentTitle: string;
  @Input('ghContactMenuDialogParentTitleParams') params: Hash<any>;

  @Output() change = new EventEmitter<ContactChangeEvent>();

  constructor(private dialogs: DialogService,
              @Self() private contactMenu: ContactMenuComponent) {

  }

  ngOnInit(): void {
    this.contactMenu.create
      .subscribe(() => this.openDialog());
    this.contactMenu.open
      .subscribe((contact: any) => this.openDialog(contact));
  }

  private openDialog(openedContact?: any): void {
    const { entryPoint, parentTitle } = this;
    this.dialogs.openWithInput(contactDetailsDialogRoute, <ContactDetailsDialogConfig>{
      contactType: ContactType.Customer,
      contactId: openedContact ? openedContact.contactId : void 0,
      entryPoint,
      parentTitle,
    }).afterClosed().pipe(
      filter$(Boolean))
      .subscribe((contact: any) => this.change.emit(contact));
  }
}
